// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Contingency model belongsTo relations 1`] = `
Array [
  "Project",
]
`;
